import { MarkOrdersForInvoicingMutation } from "~/gql/mutations/invoices.generated";
import {
	GetCustomerReceivablesQuery,
	GetReceivablesAgingTotalsQuery
} from "~/gql/queries/customerReceivables.generated";

export const invoicesEndpoints = {
	GetCustomerReceivables: {
		providesTags: ["CustomerReceivables"] as AddTagTypes,
		transformResponse: (res: GetCustomerReceivablesQuery) => res
	},
	GetReceivablesAgingTotals: {
		providesTags: ["CustomerReceivables"] as AddTagTypes,
		transformResponse: (res: GetReceivablesAgingTotalsQuery) => res
	},
	MarkOrdersForInvoicing: {
		invalidatesTags: ["CustomerReceivables", "Orders", "Learning"] as AddTagTypes,
		transformResponse: (res: MarkOrdersForInvoicingMutation) => res
	}
};
